import React, { FC, HTMLProps } from "react";
import { Icon } from "../../../general/Icon";
import "./styles.scss";

interface iProps extends HTMLProps<HTMLDivElement> {
    itemId?: string,
    url?: any,
    fa?: any,
    title?: any,
    active?: any
}

export const ReportCheckboxSelectorLabel: FC<iProps> = ({ itemId, url, fa, title, active, className = "", ...props }) => {
    return (
        <div
            key={itemId}
            className={`checkbox-selector ${active ? "checked" : ""} ${className}`}
            {...props}
        >
            <input
                type="checkbox"
                checked={active}
                className="hidden-checkbox"
            />
            <div className="checkbox-box">
                {active && (
                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M5 12.5L10 17.5L19 6.5"
                            fill="none"
                            stroke="white"
                            strokeWidth="4"
                            strokeLinecap="square"
                        />
                    </svg>
                )}
            </div>
            <div className="checkbox-label">{title}</div>
        </div>
    )
}